import urls from 'constants/urls.json';
import { getModules } from 'modules/api';

export const MODULES_REQUEST = 'MODULES_REQUEST';
export const MODULES_RECEIVED = 'MODULES_RECEIVED';

export const requestModules = () => {
  return { type: MODULES_REQUEST };
};

export const receivedModules = (modules) => {
  return { type: MODULES_RECEIVED, modules };
};

export const fetchModules = () => {
  return async (dispatch) => {
    dispatch(requestModules());

    const modules = await getModules(urls['modules']);

    if (!modules) return dispatch(receivedModules([]));

    dispatch(receivedModules(modules));
  };
};
